import React from 'react';
import Seat from '../../../components/Seat';
import WagonDoor from '../../../components/WagonDoor';
import WagonToilet from '../../../components/WagonToilet';

function FirstFloor({
  seats, chosenSeats, setChosenSeats, wagonNumber, unReserveSeat, reserveSeat,
}) {
  return (
    <div>
      <div className="wagon">
        <div className="wagon-floor">
          <h2>I</h2>
        </div>
        <div
          className="seats-row left "
          style={{ width: '755.3px', marginLeft: '40px' }}
        />
        <div
          className="seats-row left"
          style={{ marginLeft: '94px' }}
        >
          <WagonDoor />
          {
              [
                [16, 15], [14, 13], [12, 11], [10, 9], [8, 7], [6, 5], [4, 3], [2, 1],
              ].map((seatsPair, index) => (
                <React.Fragment key={seatsPair[0]}>
                  <div className="seat-column relative">
                    {!index && <div className="border border-solid w-[1px] h-[110px] -bottom-2 absolute left-1" />}
                    <Seat
                      seat={seats?.[seatsPair[0]]}
                      chosenSeats={chosenSeats}
                      setChosenSeats={setChosenSeats}
                      wagonNumber={wagonNumber}
                      reserveSeat={reserveSeat}
                      unReserveSeat={unReserveSeat}
                      noDirection
                      hidePrice
                    />
                    <Seat
                      seat={seats?.[seatsPair[1]]}
                      chosenSeats={chosenSeats}
                      setChosenSeats={setChosenSeats}
                      wagonNumber={wagonNumber}
                      reserveSeat={reserveSeat}
                      unReserveSeat={unReserveSeat}
                      noDirection
                      hidePrice
                      bottom
                    />
                  </div>
                  <div className="relative">
                    <WagonToilet />
                    <div className="border border-solid w-[1px] h-[110px] -bottom-2 absolute -right-3" />
                  </div>

                </React.Fragment>
              ))
          }
          <WagonDoor className="!ml-2" />
        </div>
      </div>
    </div>
  );
}

export default FirstFloor;
